var app = angular.module("leonardo");

var WorkFlowListActions = function ($scope, $state, ngDialog, PermissionService, $rootScope, ReportService, FilterService) {

  $scope.by_unit = $state.current.by_unit;

  if ($scope.by_unit) {
    $scope.type = 'Unit Workflow';
  }
  else {
    $scope.type = 'Workflow';
  }

  $scope.permissionService = PermissionService;

  $scope.showAdd = ($state.current.name === 'unit-turn.workflows') || ($state.current.name === 'workflows.workflows');

  $scope.goToWorkFlowAdd = function () {
    if ($scope.by_unit) {
      $state.go('unit-turn.workflows.add');
    }
    else {
      $state.go('workflows.workflows.add');
    }
  };

  $scope.goToWorkFlowReport = function () {
    ReportService.setQuickReport({filters: FilterService.filters});
    $rootScope.$broadcast('no_reset_filters:updated', true);
    if ($scope.by_unit) {
      $state.go('reports.unit');
    }
    else {
      $state.go('reports.workflow');
    }
  };
};

app.controller('WorkFlowListActions', ['$scope', '$state', 'ngDialog', 'PermissionService', '$rootScope',
  'ReportService', 'FilterService', WorkFlowListActions]);